import { Component, Input } from '@angular/core';
import { ClientDetails } from 'src/app/interfaces/home.interface';

@Component({
  selector: 'app-satisfaction-graph',
  templateUrl: './satisfaction-graph.component.html',
  styleUrls: ['./satisfaction-graph.component.scss'],
})
export class SatisfactionGraphComponent {
  @Input() rating: number | string = 0;
  @Input() clientDetails!:ClientDetails;
  constructor(){

  }
  ngOnInit(): void {
    // console.log(this.clientDetails)
  }
}
